import { NgModule } from '@angular/core';
import { DashboardGuard } from './dashboard.guard';

@NgModule({
  providers: [ DashboardGuard ]
})
export class GuardsModule {
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/guards/guards.module.ts